import {
    AddDiscountDTO,
    ChildId,
    DiscountApplyType,
    DiscountFormFields,
    DiscountTarget,
    DiscountType,
    EditDiscountDTO,
    EditDiscountFormFields,
} from 'types';
import { parseDayjsDateIntoString } from '../dateTime/parseDayjsDateIntoString';

export const parseAddDiscountsFormFieldsToAddDiscountDTO = (
    childId: ChildId,
    discountFormFields: DiscountFormFields,
): AddDiscountDTO => {
    const isEndDiscount = discountFormFields.applyType === DiscountApplyType.CATEGORY;

    return {
        childId,
        amount: discountFormFields.amount,
        discountType: discountFormFields.discountType as DiscountType,
        discountTarget: discountFormFields.discountTarget as DiscountTarget,
        applyType: discountFormFields.applyType as DiscountApplyType,
        startDate: parseDayjsDateIntoString(
            isEndDiscount
                ? discountFormFields.startDate.startOf('month')
                : discountFormFields.startDate,
            'YYYY-MM-DD',
        ),
        name: discountFormFields.name,
        courseId: discountFormFields.courseId,
        endDate: parseDayjsDateIntoString(
            isEndDiscount ? discountFormFields.endDate.endOf('month') : discountFormFields.endDate,
            'YYYY-MM-DD',
        ),
    };
};

export const parseEditDiscountsFormFieldsToAddDiscountDTO = (
    discountFormFields: EditDiscountFormFields,
): EditDiscountDTO => {
    const isEndDiscount = discountFormFields.applyType === DiscountApplyType.CATEGORY;

    return {
        amount: discountFormFields.amount,
        startDate: parseDayjsDateIntoString(
            isEndDiscount
                ? discountFormFields.startDate.startOf('month')
                : discountFormFields.startDate,
            'YYYY-MM-DD',
        ),
        name: discountFormFields.name,
        courseId: discountFormFields.courseId,
        endDate: parseDayjsDateIntoString(
            isEndDiscount ? discountFormFields.endDate.endOf('month') : discountFormFields.endDate,
            'YYYY-MM-DD',
        ),
    };
};
